import { Avatar, Box, Dialog, DialogContent, DialogTitle, IconButton, List, ListItem, ListItemAvatar, ListItemButton, ListItemText, styled } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
      padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
      padding: theme.spacing(1),
    },
  }));

const paymentMethod = [
    {id: 1, name: "Mandiri Virtual Account", channel: "MANDIRI", logo: "Mandiri.png", pg: "Xendit"},
    {id: 2, name: "BRI Virtual Account", channel: "BRI", logo: "BRI.png", pg: "Xendit"},
    {id: 3, name: "BNI Virtual Account", channel: "BNI", logo: "BNI.png", pg: "Xendit"},
    {id: 4, name: "BSI Virtual Account", channel: "BSI", logo: "BSI.png", pg: "Xendit"},
    {id: 5, name: "BJB Virtual Account", channel: "BJB", logo: "BJB.png", pg: "Xendit"},
    {id: 6, name: "CIMB Virtual Account", channel: "CIMB", logo: "CIMB.png", pg: "Xendit"},
    {id: 7, name: "Permata Virtual Account", channel: "PERMATA", logo: "Permata.png", pg: "Xendit"},
    {id: 8, name: "BSS Virtual Account", channel: "SAMPOERNA", logo: "BSS.png", pg: "Xendit"},
    {id: 9, name: "QRIS", channel: "QRIS", logo: "QRIS.png", pg: "Xendit"},
    {id: 10, name: "Alfamart / Alfamidi", channel: "ALFAMART", logo: "Alfamart.png", pg: "Xendit"},
    {id: 11, name: "Dana", channel: "DANA", logo: "DANA.png", pg: "Xendit"},
    {id: 12, name: "OVO", channel: "OVO", logo: "OVO.png", pg: "Xendit"},
    {id: 13, name: "ShopeePay", channel: "SHOPEEPAY", logo: "Shopee.png", pg: "Xendit"},
    {id: 14, name: "LinkAja", channel: "LINKAJA", logo: "LinkAja.png", pg: "Xendit"},
    {id: 15, name: "BRILink", channel: "BRILINK", logo: "BRILINK.png", pg: "Xendit"},
    {id: 16, name: "Indomaret", channel: "INDOMARET", logo: "Indomaret.png", pg: "Xendit"},
    {id: 17, name: "Gopay", channel: "GOPAY", logo: "Gopay.png", pg: "Xendit"},
]

const ModalXendit = ({dialog, handleDialog, handlePayment, channel}) => {

    return (
        <BootstrapDialog
            fullWidth
            maxWidth={"xs"}
            aria-labelledby="customized-dialog-title"
            open={dialog}
        >
            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                Xendit - Payment Channel
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={() => handleDialog(false)}
                sx={(theme) => ({
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: theme.palette.grey[500],
                })}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent dividers>
                <Box sx={{ width: '100%'}}>
                    <List dense sx={{ width: '100%', bgcolor: 'background.paper' }}>
                        {channel.map((chan, index) => {
                            if (chan === "MANDIRI") {
                                return <ListItem
                                    key={index}
                                    secondaryAction={
                                        <IconButton edge="end" aria-label="delete" onClick={() => handlePayment(chan)}>
                                            <KeyboardArrowRightIcon />
                                        </IconButton>
                                    }
                                    disablePadding
                                >
                                    <ListItemButton
                                        onClick={() => handlePayment(chan)}
                                    >
                                        <ListItemAvatar>
                                            <Avatar
                                                variant="square"
                                                alt={`${chan}`}
                                                src={process.env.PUBLIC_URL + `/bank/Mandiri.png`}
                                            />
                                        </ListItemAvatar>
                                        <ListItemText primary={`Mandiri Virtual Account`} />
                                    </ListItemButton>
                                </ListItem>
                            } else if (chan === "BRI") {
                                return <ListItem
                                    key={index}
                                    secondaryAction={
                                        <IconButton edge="end" aria-label="delete" onClick={() => handlePayment(chan)}>
                                            <KeyboardArrowRightIcon />
                                        </IconButton>
                                    }
                                    disablePadding
                                >
                                    <ListItemButton
                                        onClick={() => handlePayment(chan)}
                                    >
                                        <ListItemAvatar>
                                            <Avatar
                                                variant="square"
                                                alt={`${chan}`}
                                                src={process.env.PUBLIC_URL + `/bank/BRI.png`}
                                            />
                                        </ListItemAvatar>
                                        <ListItemText primary={`BRI Virtual Account`} />
                                    </ListItemButton>
                                </ListItem>
                            } else if (chan === "BNI") {
                                return <ListItem
                                    key={index}
                                    secondaryAction={
                                        <IconButton edge="end" aria-label="delete" onClick={() => handlePayment(chan)}>
                                            <KeyboardArrowRightIcon />
                                        </IconButton>
                                    }
                                    disablePadding
                                >
                                    <ListItemButton
                                        onClick={() => handlePayment(chan)}
                                    >
                                        <ListItemAvatar>
                                            <Avatar
                                                variant="square"
                                                alt={`${chan}`}
                                                src={process.env.PUBLIC_URL + `/bank/BNI.png`}
                                            />
                                        </ListItemAvatar>
                                        <ListItemText primary={`BNI Virtual Account`} />
                                    </ListItemButton>
                                </ListItem>
                            } else if (chan === "BSI") {
                                return <ListItem
                                    key={index}
                                    secondaryAction={
                                        <IconButton edge="end" aria-label="delete" onClick={() => handlePayment(chan)}>
                                            <KeyboardArrowRightIcon />
                                        </IconButton>
                                    }
                                    disablePadding
                                >
                                    <ListItemButton
                                        onClick={() => handlePayment(chan)}
                                    >
                                        <ListItemAvatar>
                                            <Avatar
                                                variant="square"
                                                alt={`${chan}`}
                                                src={process.env.PUBLIC_URL + `/bank/BSI.png`}
                                            />
                                        </ListItemAvatar>
                                        <ListItemText primary={`BSI Virtual Account`} />
                                    </ListItemButton>
                                </ListItem>
                            } else if (chan === "BCA") {
                                return <ListItem
                                    key={index}
                                    secondaryAction={
                                        <IconButton edge="end" aria-label="delete" onClick={() => handlePayment(chan)}>
                                            <KeyboardArrowRightIcon />
                                        </IconButton>
                                    }
                                    disablePadding
                                >
                                    <ListItemButton
                                        onClick={() => handlePayment(chan)}
                                    >
                                        <ListItemAvatar>
                                            <Avatar
                                                variant="square"
                                                alt={`${chan}`}
                                                src={process.env.PUBLIC_URL + `/bank/BCA.png`}
                                            />
                                        </ListItemAvatar>
                                        <ListItemText primary={`BCA Virtual Account`} />
                                    </ListItemButton>
                                </ListItem>
                            } else if (chan === "BJB") {
                                return <ListItem
                                    key={index}
                                    secondaryAction={
                                        <IconButton edge="end" aria-label="delete" onClick={() => handlePayment(chan)}>
                                            <KeyboardArrowRightIcon />
                                        </IconButton>
                                    }
                                    disablePadding
                                >
                                    <ListItemButton
                                        onClick={() => handlePayment(chan)}
                                    >
                                        <ListItemAvatar>
                                            <Avatar
                                                variant="square"
                                                alt={`${chan}`}
                                                src={process.env.PUBLIC_URL + `/bank/BJB.png`}
                                            />
                                        </ListItemAvatar>
                                        <ListItemText primary={`BJB Virtual Account`} />
                                    </ListItemButton>
                                </ListItem>
                            } else if (chan === "CIMB") {
                                return <ListItem
                                    key={index}
                                    secondaryAction={
                                        <IconButton edge="end" aria-label="delete" onClick={() => handlePayment(chan)}>
                                            <KeyboardArrowRightIcon />
                                        </IconButton>
                                    }
                                    disablePadding
                                >
                                    <ListItemButton
                                        onClick={() => handlePayment(chan)}
                                    >
                                        <ListItemAvatar>
                                            <Avatar
                                                variant="square"
                                                alt={`${chan}`}
                                                src={process.env.PUBLIC_URL + `/bank/CIMB.png`}
                                            />
                                        </ListItemAvatar>
                                        <ListItemText primary={`CIMB Virtual Account`} />
                                    </ListItemButton>
                                </ListItem>
                            } else if (chan === "BSS") {
                                return <ListItem
                                    key={index}
                                    secondaryAction={
                                        <IconButton edge="end" aria-label="delete" onClick={() => handlePayment(chan)}>
                                            <KeyboardArrowRightIcon />
                                        </IconButton>
                                    }
                                    disablePadding
                                >
                                    <ListItemButton
                                        onClick={() => handlePayment(chan)}
                                    >
                                        <ListItemAvatar>
                                            <Avatar
                                                variant="square"
                                                alt={`${chan}`}
                                                src={process.env.PUBLIC_URL + `/bank/BSS.png`}
                                            />
                                        </ListItemAvatar>
                                        <ListItemText primary={`BSS Virtual Account`} />
                                    </ListItemButton>
                                </ListItem>
                            } else if (chan === "PERMATA") {
                                return <ListItem
                                    key={index}
                                    secondaryAction={
                                        <IconButton edge="end" aria-label="delete" onClick={() => handlePayment(chan)}>
                                            <KeyboardArrowRightIcon />
                                        </IconButton>
                                    }
                                    disablePadding
                                >
                                    <ListItemButton
                                        onClick={() => handlePayment(chan)}
                                    >
                                        <ListItemAvatar>
                                            <Avatar
                                                variant="square"
                                                alt={`${chan}`}
                                                src={process.env.PUBLIC_URL + `/bank/Permata.png`}
                                            />
                                        </ListItemAvatar>
                                        <ListItemText primary={`Permata Virtual Account`} />
                                    </ListItemButton>
                                </ListItem>
                            } else if (chan === "ALFAMART") {
                                return <ListItem
                                    key={index}
                                    secondaryAction={
                                        <IconButton edge="end" aria-label="delete" onClick={() => handlePayment(chan)}>
                                            <KeyboardArrowRightIcon />
                                        </IconButton>
                                    }
                                    disablePadding
                                >
                                    <ListItemButton
                                        onClick={() => handlePayment(chan)}
                                    >
                                        <ListItemAvatar>
                                            <Avatar
                                                variant="square"
                                                alt={`${chan}`}
                                                src={process.env.PUBLIC_URL + `/bank/Alfamart.png`}
                                            />
                                        </ListItemAvatar>
                                        <ListItemText primary={`AlfaMart`} />
                                    </ListItemButton>
                                </ListItem>
                            } else if (chan === "INDOMARET") {
                                return <ListItem
                                    key={index}
                                    secondaryAction={
                                        <IconButton edge="end" aria-label="delete" onClick={() => handlePayment(chan)}>
                                            <KeyboardArrowRightIcon />
                                        </IconButton>
                                    }
                                    disablePadding
                                >
                                    <ListItemButton
                                        onClick={() => handlePayment(chan)}
                                    >
                                        <ListItemAvatar>
                                            <Avatar
                                                variant="square"
                                                alt={`${chan}`}
                                                src={process.env.PUBLIC_URL + `/bank/Indomaret.png`}
                                            />
                                        </ListItemAvatar>
                                        <ListItemText primary={`IndoMaret`} />
                                    </ListItemButton>
                                </ListItem>
                            } else if (chan === "GOPAY") {
                                return <ListItem
                                    key={index}
                                    secondaryAction={
                                        <IconButton edge="end" aria-label="delete" onClick={() => handlePayment(chan)}>
                                            <KeyboardArrowRightIcon />
                                        </IconButton>
                                    }
                                    disablePadding
                                >
                                    <ListItemButton
                                        onClick={() => handlePayment(chan)}
                                    >
                                        <ListItemAvatar>
                                            <Avatar
                                                variant="square"
                                                alt={`${chan}`}
                                                src={process.env.PUBLIC_URL + `/bank/Gopay.png`}
                                            />
                                        </ListItemAvatar>
                                        <ListItemText primary={`GoPay`} />
                                    </ListItemButton>
                                </ListItem>
                            } else if (chan === "OVO") {
                                return <ListItem
                                    key={index}
                                    secondaryAction={
                                        <IconButton edge="end" aria-label="delete" onClick={() => handlePayment(chan)}>
                                            <KeyboardArrowRightIcon />
                                        </IconButton>
                                    }
                                    disablePadding
                                >
                                    <ListItemButton
                                        onClick={() => handlePayment(chan)}
                                    >
                                        <ListItemAvatar>
                                            <Avatar
                                                variant="square"
                                                alt={`${chan}`}
                                                src={process.env.PUBLIC_URL + `/bank/OVO.png`}
                                            />
                                        </ListItemAvatar>
                                        <ListItemText primary={`OVO`} />
                                    </ListItemButton>
                                </ListItem>
                            } else if (chan === "DANA") {
                                return <ListItem
                                    key={index}
                                    secondaryAction={
                                        <IconButton edge="end" aria-label="delete" onClick={() => handlePayment(chan)}>
                                            <KeyboardArrowRightIcon />
                                        </IconButton>
                                    }
                                    disablePadding
                                >
                                    <ListItemButton
                                        onClick={() => handlePayment(chan)}
                                    >
                                        <ListItemAvatar>
                                            <Avatar
                                                variant="square"
                                                alt={`${chan}`}
                                                src={process.env.PUBLIC_URL + `/bank/DANA.png`}
                                            />
                                        </ListItemAvatar>
                                        <ListItemText primary={`Dana`} />
                                    </ListItemButton>
                                </ListItem>
                            } else if (chan === "LINKAJA") {
                                return <ListItem
                                    key={index}
                                    secondaryAction={
                                        <IconButton edge="end" aria-label="delete" onClick={() => handlePayment(chan)}>
                                            <KeyboardArrowRightIcon />
                                        </IconButton>
                                    }
                                    disablePadding
                                >
                                    <ListItemButton
                                        onClick={() => handlePayment(chan)}
                                    >
                                        <ListItemAvatar>
                                            <Avatar
                                                variant="square"
                                                alt={`${chan}`}
                                                src={process.env.PUBLIC_URL + `/bank/LinkAja.png`}
                                            />
                                        </ListItemAvatar>
                                        <ListItemText primary={`LinkAja`} />
                                    </ListItemButton>
                                </ListItem>
                            } else if (chan === "SHOPEEPAY") {
                                return <ListItem
                                    key={index}
                                    secondaryAction={
                                        <IconButton edge="end" aria-label="delete" onClick={() => handlePayment(chan)}>
                                            <KeyboardArrowRightIcon />
                                        </IconButton>
                                    }
                                    disablePadding
                                >
                                    <ListItemButton
                                        onClick={() => handlePayment(chan)}
                                    >
                                        <ListItemAvatar>
                                            <Avatar
                                                variant="square"
                                                alt={`${chan}`}
                                                src={process.env.PUBLIC_URL + `/bank/Shopee.png`}
                                            />
                                        </ListItemAvatar>
                                        <ListItemText primary={`ShopeePay`} />
                                    </ListItemButton>
                                </ListItem>
                            } else if (chan === "QRIS") {
                                return <ListItem
                                    key={index}
                                    secondaryAction={
                                        <IconButton edge="end" aria-label="delete" onClick={() => handlePayment(chan)}>
                                            <KeyboardArrowRightIcon />
                                        </IconButton>
                                    }
                                    disablePadding
                                >
                                    <ListItemButton
                                        onClick={() => handlePayment(chan)}
                                    >
                                        <ListItemAvatar>
                                            <Avatar
                                                variant="square"
                                                alt={`${chan}`}
                                                src={process.env.PUBLIC_URL + `/bank/QRIS.png`}
                                            />
                                        </ListItemAvatar>
                                        <ListItemText primary={`QRIS`} />
                                    </ListItemButton>
                                </ListItem>
                            }
                            }
                        )}
                    </List>
                </Box>
            </DialogContent>
        </BootstrapDialog>
    )
}

export default ModalXendit;